import { GrFacebookOption } from "react-icons/gr";

const Footer = ({ translate }) => (
    <div className="footer-wrap">
      <div>
        <p className="copyright-text">© {new Date().getFullYear()} Sonodome / All rights reserved</p>
        <p className="footer-version">v 2.0.0</p>
      </div>
      <div className="contact-us-footer">
        <p>
          {translate("contactUs")}
        </p>
        <a
          className="facebook-icon-link"
          href="https://www.facebook.com/groups/bookingapp"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Facebook group"
        >
          <GrFacebookOption />
        </a>
      </div>
    </div>
  );

export default Footer;
